import { backgroundImageDirective, backgroundColorDirective } from "@wittignl/js-core";

export default function(app){

    app.directive('background-image', backgroundImageDirective);
    app.directive('background-color', backgroundColorDirective);
}